import types from '../../../mutation-types';
import ConversationApi from '../../../../api/inbox/conversation';

const actions = {
  pinConversation: async ({ commit }, conversationId) => {
    try {
      await ConversationApi.pin(conversationId);
      commit(types.PIN_CONVERSATION, conversationId);
    } catch (error) {
      throw new Error(error);
    }
  },

  unpinConversation: async ({ commit }, conversationId) => {
    try {
      await ConversationApi.unpin(conversationId);
      commit(types.UNPIN_CONVERSATION, conversationId);
    } catch (error) {
      throw new Error(error);
    }
  },
};

export default actions;
